"use client"

import { useState, useEffect } from "react"
import { Tooltip } from "react-tooltip"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getNotesAction, sendDoctorNoteReplyAction } from "../../../../../store/actions/NotesAction"
import { Button, Modal } from "react-bootstrap"
import avatar1 from "../../../../../assets/images/avatar/1.png"
import avatar2 from "../../../../../assets/images/avatar/2.png"
import replyIcon from "../../../../../../src/assets/images/reply.png"
import AddNotes from "./AddNotes.Component"

export const PatientNotes = (props) => {
  const dispatch = useDispatch()
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [reply, setReply] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [currentNoteId, setCurrentNoteId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleShow = () => setShowModal(true)
  // const handleClose = () => setShowModal(false)
  const handleClose = (medicineId = null) => {
    setShowModal(false);
    if (medicineId) {
      console.log("Medicine added from note:", medicineId);
      // TODO: add medicine to prescription table automatically
    }
  };
  const userDetails = JSON.parse(localStorage.getItem("userDetails"))
  const admin_id = userDetails?.admin_id || 0
  const patientDetails = useSelector((state) => state.patients?.patientDetails)
  const patientId = patientDetails?.patient_id

  var notes = useSelector((state) => {
    console.log("notes:", state.notes)
    return state.notes?.notes || []
  })

  useEffect(() => {
    if (patientId) {
      dispatch(getNotesAction(patientId))
    }
  }, [dispatch, patientId])

  // Callback after adding a note
  const handleNoteAdded = (medicineId = null) => {
    if (patientId) {
      dispatch(getNotesAction(patientId));
    }

    if (medicineId) {
      console.log("Medicine received from AddNotes:", medicineId);
      // TODO: your add-to-prescription logic here
    }

    handleClose();
  };


  const handleOpen = (e, noteId) => {
    e.preventDefault()
    setCurrentNoteId(noteId)
    setModalIsOpen(true)
  }

  const handleSendReply = async () => {
    if (!reply.trim() || !currentNoteId) {
      alert("Please enter a reply")
      return
    }

    setIsSubmitting(true)
    try {
      const result = await dispatch(sendDoctorNoteReplyAction(currentNoteId, reply))

      if (result.success) {
        console.log("Reply sent successfully:", result)
        setReply("")
        setModalIsOpen(false)
        setCurrentNoteId(null)

        // Refresh notes to show the updated reply
        if (patientId) {
          dispatch(getNotesAction(patientId))
        }
      } else {
        alert("Failed to send reply. Please try again.")
      }
    } catch (error) {
      console.error("Error sending reply:", error)
      alert("Failed to send reply. Please try again.")
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleCloseReplyModal = () => {
    setModalIsOpen(false)
    setReply("")
    setCurrentNoteId(null)
  }

  return (
    <div className="card shadow-none">
      <div className="card-body">
        {/* Notes Button */}
        <div className="text-end mb-3">
          <Button variant="outline-primary" size="sm" onClick={handleShow}>
            Add Notes
          </Button>
        </div>

        <div
          className={`card-body msg_card_body dz-scroll`}
          style={{
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          {notes.map((note) => {
            if (note.created_by != admin_id)
              return (
                <div className="mb-4" key={note.note_id}>
                  <div className="d-flex justify-content-start align-items-center">
                    <div className="img_cont_msg">
                      <img
                        src={avatar1 || "/placeholder.svg"}
                        className="rounded-circle user_img_msg"
                        alt="Patient Avatar"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          cursor: "pointer",
                          marginRight: "10px",
                        }}
                        data-tooltip-id="doctor-tooltip"
                        data-tooltip-content={note.created_by_name || "Anonymous"}
                      />
                      <Tooltip
                        id="doctor-tooltip"
                        place="top"
                        style={{
                          backgroundColor: "black",
                          color: "white",
                        }}
                      />
                    </div>
                    <div
                      className="msg_cotainer"
                      style={{
                        backgroundColor: "#36c95f",
                        borderRadius: "15px",
                        padding: "10px",
                        maxWidth: "70%",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                        color: "white",
                      }}
                    >
                      {/* Optional: Note Type / Doctor */}
                      <div
                        className="msg_title"
                        style={{
                          fontWeight: "bold",
                          color: "white",
                          fontSize: "16px",
                          marginBottom: "5px",
                        }}
                      >
                        {/* note.note_type || "Note" */}
                      </div>

                      {/* Note Description + Reply Icon */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <div style={{ flex: 1, paddingRight: "10px" }}>{note.note_description}</div>

                        {/* Timestamp */}
                        <span className="msg_time fs-12 mb-0">{new Date(note.created_at).toLocaleString()}</span>
                        {/* Only show reply icon if it's an emergency and no doctor reply exists */}
                        {note.is_emergency === "Yes" && (!note.doctor_reply || note.doctor_reply === "") && (
                          <Link to="#" onClick={(e) => handleOpen(e, note.note_id)}>
                            <img
                              src={replyIcon || "/placeholder.svg"}
                              alt="reply icon"
                              style={{
                                marginLeft: "2rem",
                                cursor: "pointer",
                                width: "25px",
                                height: "25px",
                              }}
                            />
                          </Link>
                        )}
                      </div>

                      {/* Show doctor reply if exists */}
                      {note.doctor_reply && (
                        <div
                          style={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            borderRadius: "8px",
                            padding: "8px",
                            marginTop: "8px",
                            fontSize: "14px",
                          }}
                        >
                          <strong>Doctor Reply:</strong> {note.doctor_reply}
                          {note.doctor_reply_date && (
                            <div style={{ fontSize: "12px", marginTop: "4px" }}>
                              {new Date(note.doctor_reply_date).toLocaleString()}
                            </div>
                          )}
                        </div>
                      )}


                    </div>
                  </div>
                </div>
              )
            else
              return (
                <div className="mb-4" key={note.note_id}>
                  <div className="d-flex justify-content-end align-items-center">
                    <div
                      className="msg_cotainer_send"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "15px",
                        padding: "10px",
                        maxWidth: "70%",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div
                        className="msg_title"
                        style={{
                          fontWeight: "bold",
                          fontSize: "14px",
                          marginBottom: "1px",
                        }}
                      >
                        {/*note.note_type || "Note"*/}
                        {note.note_type === "Doctor" ? "Medical" : "Non-Medical"}
                      </div>
                      {note.note_description}
                      <br />
                      <span className="msg_time_send fs-12 mb-0">{new Date(note.created_at).toLocaleString()}</span>
                    </div>
                    <div className="img_cont_msg">
                      <img
                        src={avatar2 || "/placeholder.svg"}
                        className="rounded-circle user_img_msg"
                        alt="Doctor Avatar"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          marginLeft: "10px",
                        }}
                        data-tooltip-id="doctor-tooltip"
                        data-tooltip-content={note.created_by_name || "Anonymous"}
                      />
                      <Tooltip id="doctor-tooltip" place="top" />
                    </div>
                  </div>
                </div>
              )
          })}
        </div>

        {/* Reply Modal */}
        <Modal show={modalIsOpen} onHide={handleCloseReplyModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Reply to Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control"
              rows={4}
              value={reply}
              onChange={(e) => setReply(e.target.value)}
              placeholder="Type your reply here..."
              disabled={isSubmitting}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-danger" onClick={handleCloseReplyModal} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSendReply} disabled={isSubmitting || !reply.trim()}>
              {isSubmitting ? "Sending..." : "Send"}
            </Button>
          </Modal.Footer>
        </Modal>

        <AddNotes showModal={showModal} handleClose={handleNoteAdded}></AddNotes>
      </div>
    </div>
  )
}
